//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImgWrap from '@/components/business/img_wrap'
import type_name from '@/components/mixins/building_ranking'

export default {
    mixins: [
        type_name
    ],
    mounted () {},
    computed: {
        hide_date () {
            const { date_with_status } = this.item || {}
            return !date_with_status || (this.type === '即将预售' && date_with_status.indexOf('摇号时间') > -1)
        },
        show_price () {
            const { price_desc_arr } = this.item
            return price_desc_arr && price_desc_arr.length && this.type !== '即将预售'
        },
        new_tag_names() {
            const { coupons = [], tag_names = [] } = this.item
            let tags = []
            if (coupons.length) {
                tags.push({
                    name: '优惠券',
                    style: 'red'
                })
            }
            if (tag_names.length) {
                tags = tags.concat(tag_names)
            }
            return tags
        },
        new_date_with_status() {
            const { date_with_status } = this.item || {}
            if (date_with_status) {
                const value_split = date_with_status.split('：')
                return {
                    label: value_split[0],
                    value: value_split[1]
                }
            }
            return ''
        },
        show_date_with_status() {
            return !this.hide_date && this.new_date_with_status
        },
        row_len() {
            return [
                this.show_price,
                this.new_tag_names.length > 0,
                this.show_date_with_status,
            ].filter(v => v).length + 2
        }
    },
    methods: {
        goDetail (e) {
            if (this.just_view) {
                return
            }
            const { building_id } = this.item
            wx.navigateTo({
                url: `/building/main?building_id=${building_id}`
            })
        }
    },
    components: {
       ImgWrap
    },
    props: {
        item: {
            type: Object,
            default: {}
        },
        classname: {
            type: String,
            default: ''
        },
        just_view: Boolean
    }
}
